import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle, useState } from "react";

import { useTranslation } from "react-i18next";

import Modal, { ModalType } from "../../../../../../../../../../../components/Generic/Modal";
import { Member } from "../../../../../../../../../../../models/members/member";
import { MembersType } from "../../../../../../../../../../../util/enums";
import { TypeOfMember } from "../../../../../../../../../../../util/enums/members";
import useStyles, { ModalBodySubtext, ModalBodyText, ModalBodyWrapper } from "./styles";

interface Props {
  onSubmit: (member: Member) => void;
}

export interface ConvertIntoHandler {
  onOpenModal: (member: Member) => void;
  onCloseModal: () => void;
}

const ConvertIntoModal: ForwardRefRenderFunction<ConvertIntoHandler, Props> = (props, ref) => {
  const { t: translate } = useTranslation();
  const { onSubmit } = props;
  const classes = useStyles();

  const [open, setOpen] = useState<boolean>(false);
  const [currentMember, setCurrentMember] = useState<Member>();

  const onOpenModal = (member: Member) => {
    setCurrentMember(member);
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    onOpenModal,
    onCloseModal: () => setOpen(false),
  }));

  const isMemberAUser =
    currentMember?.typeOfMember?.toLowerCase() === MembersType.USER?.toLowerCase();

  return (
    <Modal
      title={isMemberAUser ? translate("convertUserIntoStaff") : translate("convertStaffIntoUser")}
      open={open}
      handleClose={() => setOpen(false)}
      showModalFooter
      showActionButtons
      actionButtonProps={{
        onCancel: () => setOpen(false),
        onSave: () =>
          currentMember
            ? onSubmit({
                ...currentMember,
                typeOfMember: isMemberAUser ? TypeOfMember.STAFF : TypeOfMember.USER,
              })
            : null,
        showSaveButton: true,
        showCancelButton: true,
        textSave: translate("save"),
      }}
      type={ModalType.INFO}
      className={classes.modalWrapper}
    >
      <ModalBodyWrapper>
        <ModalBodyText>
          {isMemberAUser
            ? translate("doYouWantToConvertThisUserIntoStaff")
            : translate("doYouWantToConvertThisStaffIntoUser")}
        </ModalBodyText>
        <ModalBodySubtext>{translate("youWillNeedToFillInTheMissigInformation")}</ModalBodySubtext>
      </ModalBodyWrapper>
    </Modal>
  );
};

export default forwardRef(ConvertIntoModal);
